import { useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { bookUrl } from "../data/siteConfig";

export const Lightbox = ({ item, onClose }) => {
  useEffect(() => {
    if (!item) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [item, onClose]);

  return (
    <AnimatePresence>
      {item && (
        <motion.div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/90 p-4 backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          role="dialog"
          aria-modal="true"
          aria-label={item.style}
          data-testid="gallery-lightbox"
        >
          <motion.figure
            className="w-full max-w-3xl"
            initial={{ opacity: 0, scale: 0.94, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img
                src={item.src}
                alt={item.alt}
                className="max-h-[70vh] w-full rounded-2xl border border-white/10 object-contain bg-coal"
              />
              <button
                onClick={onClose}
                aria-label="Close"
                data-testid="lightbox-close"
                className="absolute right-3 top-3 rounded-full bg-black/70 p-2 transition-colors duration-300 hover:bg-hotpink"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <figcaption className="mt-4 flex flex-wrap items-center justify-between gap-4">
              <div>
                <p className="font-serif text-xl">{item.style}</p>
                <p className="text-xs uppercase tracking-[0.25em] text-hotpink">
                  {item.category}
                </p>
              </div>
              {item.serviceId && (
                <Link
                  to={bookUrl(item.serviceId)}
                  data-testid="lightbox-book-this-look"
                  className="rounded-full bg-hotpink px-6 py-2.5 text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-magenta"
                >
                  Book This Look
                </Link>
              )}
            </figcaption>
          </motion.figure>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

